import React from 'react';
import { Text, Button, Input, Select } from 'v3/components';
import { getInternationalDocPlaceholder } from '../Utils/masks';
import { styles } from '../styles';

export default function IdentificationStep({
  docTypeOptions,
  docTypeSelected,
  errorTextStyle,
  handleNextFromForm,
  hasPersonError,
  inputErrorStyle,
  isMobile,
  locked,
  mobileInputProps,
  person,
  personErrors,
  setPerson,
  setPersonField,
  touchPersonField,
}) {
  return (
    <div style={styles.card}>
      <Text type="header" color="dark" style={{ fontWeight: 800 }}>
        Identificação
      </Text>

      <div style={styles.formGrid(isMobile)}>
        <div>
          <Text type="small" color="gray">
            Nome
          </Text>
          <Input
            value={person.firstName}
            onChange={setPersonField('firstName')}
            onBlur={() => touchPersonField('firstName')}
            placeholder="Seu nome"
            style={inputErrorStyle('firstName')}
            disabled={locked}
            {...mobileInputProps}
          />
          {hasPersonError('firstName') && (
            <div style={errorTextStyle}>* {personErrors.firstName}</div>
          )}
        </div>

        <div>
          <Text type="small" color="gray">
            Sobrenome
          </Text>
          <Input
            value={person.lastName}
            onChange={setPersonField('lastName')}
            onBlur={() => touchPersonField('lastName')}
            placeholder="Seu sobrenome"
            style={inputErrorStyle('lastName')}
            disabled={locked}
            {...mobileInputProps}
          />
          {hasPersonError('lastName') && (
            <div style={errorTextStyle}>* {personErrors.lastName}</div>
          )}
        </div>

        <div>
          <Text type="small" color="gray">
            E-mail
          </Text>
          <Input
            value={person.email}
            onChange={setPersonField('email')}
            onBlur={() => touchPersonField('email')}
            placeholder="seuemail@exemplo.com"
            style={inputErrorStyle('email')}
            disabled={locked}
            {...mobileInputProps}
          />
          {hasPersonError('email') && (
            <div style={errorTextStyle}>* {personErrors.email}</div>
          )}
        </div>

        <div>
          <Text type="small" color="gray">
            Telefone
          </Text>

          <div style={styles.phoneRow}>
            <div style={styles.ddiField}>
              <Input
                value={person.ddi}
                onChange={setPersonField('ddi', { mask: 'ddi' })}
                onBlur={() => touchPersonField('ddi')}
                placeholder="DDI"
                style={inputErrorStyle('ddi')}
                disabled={locked}
                {...mobileInputProps}
              />
            </div>

            <div style={styles.phoneField}>
              <Input
                value={person.phone}
                onChange={setPersonField('phone', { mask: 'phone' })}
                onBlur={() => touchPersonField('phone')}
                placeholder="(xx) xxxxx-xxxx"
                style={inputErrorStyle('phone')}
                disabled={locked}
                {...mobileInputProps}
              />
            </div>
          </div>

          {(hasPersonError('ddi') || hasPersonError('phone')) && (
            <div style={errorTextStyle}>
              * {personErrors.ddi || personErrors.phone}
            </div>
          )}
        </div>

        <div>
          <Text type="small" color="gray">
            Tipo de documento
          </Text>
          <Select
            options={docTypeOptions}
            value={docTypeSelected}
            placeholder="Selecione..."
            isDisabled={locked}
            menuFontSize={isMobile ? '16px' : '14px'}
            disableSearch
            disableClear
            error={hasPersonError('docType') ? personErrors.docType : null}
            onBlur={() => touchPersonField('docType')}
            onChange={opt => {
              const nextType = opt?.value || 'cpfCnpj';

              setPerson(prev => ({
                ...prev,
                docType: nextType,
                docValue: '',
              }));

              touchPersonField('docType');
            }}
            styles={{
              menuPortal: base => ({ ...base, zIndex: 999999 }),
            }}
            menuStyle={{ zIndex: 999999 }}
            id="docType"
          />

          {hasPersonError('docType') && (
            <div style={errorTextStyle}>* {personErrors.docType}</div>
          )}
        </div>

        <div>
          <Text type="small" color="gray">
            {person.docType === 'cpfCnpj'
              ? 'CPF/CNPJ'
              : 'Documento internacional'}
          </Text>
          <Input
            value={person.docValue}
            onChange={setPersonField('docValue', {
              mask:
                person.docType === 'cpfCnpj' ? 'cpfCnpj' : 'internationalDoc',
              ddi: person.ddi,
            })}
            onBlur={() => touchPersonField('docValue')}
            placeholder={
              person.docType === 'cpfCnpj'
                ? '000.000.000-00 / AA.AAA.AAA/AAAA-00'
                : getInternationalDocPlaceholder(person.ddi)
            }
            style={inputErrorStyle('docValue')}
            disabled={locked}
            {...mobileInputProps}
          />

          {hasPersonError('docValue') && (
            <div style={errorTextStyle}>* {personErrors.docValue}</div>
          )}
        </div>

        <div style={styles.formActions(isMobile)}>
          <Button onClick={handleNextFromForm} disabled={locked}>
            Continuar
          </Button>
        </div>
      </div>
    </div>
  );
}
